import React, { useEffect, useState } from 'react';
import { Check, X } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../api';
import { fmtDate, fmtTime } from '../../utils/timeclock';

const span = (t) => `${fmtDate(t.clockIn)} ${fmtTime(t.clockIn)} – ${t.clockOut ? fmtTime(t.clockOut) : 'missing'}`;

// Office: approve or deny staff time-change requests. Staff: see the status of their own requests.
export const ChangeRequests = ({ isOffice, onDecided }) => {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState(isOffice ? 'Pending' : 'All');
  const load = () => api.get('/timeclock/requests', { params: { status } }).then((r) => setRows(r.data.requests)).catch(() => {});
  useEffect(() => { load(); }, [status]); // eslint-disable-line react-hooks/exhaustive-deps
  const decide = async (id, approve) => {
    const note = approve ? '' : (window.prompt('Reason for denying (optional)') || '');
    try { await api.post(`/timeclock/requests/${id}/decide`, { approve, note }); toast.success(approve ? 'Approved and the time was updated' : 'Denied'); load(); onDecided?.(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Could not save'); }
  };
  return (
    <div className="space-y-3" data-testid="change-requests">
      <select value={status} onChange={(e) => setStatus(e.target.value)} className="border rounded px-2 py-1.5 text-sm" data-testid="change-requests-filter">
        {['Pending', 'Approved', 'Denied', 'All'].map((s) => <option key={s}>{s}</option>)}
      </select>
      {!rows.length && <p className="text-sm text-gray-500" data-testid="change-requests-empty">No {status === 'All' ? '' : status.toLowerCase()} requests.</p>}
      <ul className="space-y-2">
        {rows.map((r) => (
          <li key={r.id} className="border rounded-lg p-3 text-sm" data-testid={`change-request-${r.id}`}>
            <div className="flex flex-wrap justify-between gap-2">
              <span><strong>{r.staffName}</strong> · {r.kind === 'visit' ? `Visit – ${r.patientName}` : 'Shift'}</span>
              <span className={`text-xs px-2 py-0.5 rounded-full ${r.status === 'Pending' ? 'bg-amber-100 text-amber-800' : r.status === 'Approved' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>{r.status}</span>
            </div>
            <p className="text-gray-600 mt-1">Now: {span(r.current)}</p>
            <p className="text-gray-900">Asked for: {span(r.requested)}</p>
            <p className="text-gray-600 italic">"{r.reason}"</p>
            {r.decisionNote && <p className="text-gray-600">Office note: {r.decisionNote}</p>}
            {isOffice && r.status === 'Pending' && (
              <div className="flex gap-2 mt-2">
                <button onClick={() => decide(r.id, true)} className="inline-flex items-center gap-1 px-3 py-1.5 rounded bg-green-600 text-white" data-testid={`approve-${r.id}`}><Check className="w-4 h-4" />Approve</button>
                <button onClick={() => decide(r.id, false)} className="inline-flex items-center gap-1 px-3 py-1.5 rounded border border-red-300 text-red-700" data-testid={`deny-${r.id}`}><X className="w-4 h-4" />Deny</button>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
